<template>
  <div>
    <lp-modal id="lp-modal" @register="paymentRedirect" @submit="submit" :access="access" :key="access"/>
    <div v-for="(e,i) in exercices" :key="e.id">
      <ExerciceView :exercice="e">
        <template #titre="{titre}"><h3 class="text-secondary d-inline">{{ titre }}</h3></template>
        <template #type="{type}">
          <b-badge variant="warning" class="mr-2" style="position: relative; top: -4px;">{{ type }}</b-badge>
        </template>
        <template #contenu>
          <vue-editor
              :id="`editor_${e.id}`"
              :editor-options='{"modules": { "toolbar": false }}'
              v-model="e.response"
              :disabled="!!e.texte_id"
          />
        </template>
      </ExerciceView>
      <lp-button-toolbar
          @submit="modal(e)"
          :exercice="e"
          :access="access"
          :key="access"
      />
      <hr v-if="i < exercices.length-1">
    </div>
  </div>
</template>

<script>
import {Auth, Exercice, Textes} from "@/js/caller";
import ExerciceView from "@/components/exerciceView";
import {VueEditor} from "vue2-editor";
import LpButtonToolbar from "@/pages/LeconPageComponents/lpButtonToolbar";
import LpModal from "@/pages/LeconPageComponents/lpModal";


export default {
  name      : "LeconPage",
  components: {LpModal, LpButtonToolbar, ExerciceView, VueEditor},
  data() {
    return {
      access   : !!Auth.Token()?.meta?.acces_ecole,
      current  : {},
      exercices: []
    }
  },
  methods: {
    modal(e) {
      this.current = e;
      const texte  = {
        title         : e.titre,
        texte_original: e.response,
        exercice      : e.id,
      }
      if (!this.access) e.texte_id = Textes.SaveLocal({...texte, pending: true});
      this.$bvModal.show("lp-modal");
    },
    submit() {
      const {current} = this
      const texte     = {
        title         : current.titre,
        texte_original: current.response,
        exercice      : current.id,
      }
      Textes
          .Submit(texte)
          .then(
              ({id}) => {
                Textes.discardLocal(current.texte_id);
                current.texte_id = id;
              }
          )
    },
    paymentRedirect() {
      //window.open("https://www.luqei.com/b1.php?landing=TRUE", '_blank');
      document.location.href = "https://www.luqei.com/b1.php?landing=TRUE";
    },
  },
  created() {
    const id = new URL(window.location.href).searchParams.get("id") || 1;
    Auth.Register(Auth.Events.Login, () => {
      this.access = !!Auth.Token()?.meta?.acces_ecole
    })
    Exercice.List({Equal: [{field: "lecon", value: id}]})
        .then(res => {
          this.exercices = res.map(exercice => {
            return {
              ...exercice,
              response: exercice.texte_original || Exercice.FormatContenu(exercice.contenu)
            }
          })
        });
  }
}
</script>

<style>
.ql-disabled > .ql-editor > * {
  cursor: default;
}
</style>